import DepositsVerticals from './DepositsVerticals';


const DEPOSIT_HEAP_EVENT_MAP = {
    [DepositsVerticals.SAVINGS]: 'SAV Web Click',
    [DepositsVerticals.GIC]: 'GIC Web Click',
    [DepositsVerticals.CHEQUING]: 'CHQ Web Click',
    [DepositsVerticals.ROBO]: 'ROBO Web Click',
};

export default DEPOSIT_HEAP_EVENT_MAP;
